(function (){
    'use strict';

    angular
        .module('services')
        .service('TimezonesService', TimezonesService);

        TimezonesService.$inject = ['$http', 'API_BASE'];

    function TimezonesService ($http, API_BASE) {
        var service = this;

        service.getTimezones        = getTimezones;
        service.getCountryById      = getCountryById;
        service.getCountriesAdmin   = getCountriesAdmin;
        service.getRegions          = getRegions;
        service.getCities           = getCities;

        function getTimezones (cod) {
            return $http.get(API_BASE + '/timezones/list');
        }

        function getCountryById (cod) {
            return $http.get(API_BASE + '/countries/get',{params:{id:cod}});
        }

        function getCountriesAdmin (cod) {
            return $http.get(API_BASE + '/countries/list/admin',{params:{id:cod}});
        }

        function getRegions (country_id) {
            return $http.get(API_BASE + '/countries/'+country_id+'/regions/list');
        }

        function getCities (country_id, region_id) {
            return $http.get(API_BASE + '/countries/'+country_id+'/regions/'+region_id+'/cities/list');
        }

    }
})();